import 'lightgallery'
export default {
  init() {
    // JavaScript to be fired on the home page
    
    $(window).on('load', function() {
      $('#main_price').html($('.single_variation_wrap .price').html())

      const queryString = window.location.search
      let splitQueryString = queryString.split('&')
      let colorFromUrl = splitQueryString[0]
      let sizeFromUrl = splitQueryString[1]
      if(colorFromUrl && sizeFromUrl) {
        setTimeout(() => {
          $(`.variation-product[data-term-slug="${colorFromUrl.split('=')[1]}"]`).trigger('click')
          $(`.sizes-container button[data-term-slug="${sizeFromUrl.split('=')[1]}"]`).trigger('click')
        }, 1000)
      }

      $('.twitter-btn').click(function (e) {
        e.preventDefault();
        var twitterWindow = window.open('https://twitter.com/share?url=' + document.URL, 'twitter-popup', 'height=350,width=600');
        if(twitterWindow.focus) { 
          twitterWindow.focus() 
        }
        return false;
      })
  
      $('.fb-btn').click(function (e) {
        e.preventDefault();
        var facebookWindow = window.open('https://www.facebook.com/sharer/sharer.php?u=' + document.URL, 'facebook-popup', 'height=350,width=600');
        if(facebookWindow.focus) { 
          facebookWindow.focus();
        }
        return false;
      })

      if($(window).width() <= 1024) {
        $('.related ul').removeClass('.products').slick({
          slidesToShow: 2,
          loop:false,
          dots: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        })
      }

      if($(window).width() <= 768) {
        
        glalerySlider()
        
        $('.colors-container .variation-product').click(function (e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: 0,
          }, '2000');
        })

      }

      $('#pa_colour option').each(function() {
        if($(this).prop('disabled')) {
          let disableColor = $(this).val()
          $('.variation-product[data-term-slug="'+disableColor+'"]').addClass('disabled')
        }
        $('#active-color').text($('.variation-product.selected').data('term-name'))
      })

      
      $('#pa_size-men option').each(function () {
        if($(this).prop('disabled')) {
          let disableSize = $(this).val()
          $('.sizes-container button[data-term-slug="'+disableSize+'"]').prop('disabled', true)
        }
        $('#seletced_size').text($('.sizes-container button.selected').text())
      })

      $('.sizes-container button.selected').trigger('click')
      $('.variation-product.selected').trigger('click')  

      $('.sizes-container button').click(function () {
        let selectedSize = $(this).attr('data-term-slug')
        $('#seletced_size').text(selectedSize)
        $('[id^="pa_size"]').val(selectedSize).trigger('change')
        $('.sizes-container button').removeClass('selected')
        $(this).addClass('selected')
      })
  
      $('select').change(function () {
        setTimeout(() => {
          $('#main_price').html($('.single_variation_wrap .price').html())
        }, 200);
      })
  
      $('#imageContainer').lightGallery({
        selector: '.img-box',
      })
      $('.colors-container .variation-product').click(function (e) {
        e.preventDefault()
        $('#imageContainer').data('lightGallery').destroy(true);
        if($(window).width() <= 768) { $('#imageContainer').slick('destroy') }
        let selectedVariation = $(this).attr('data-gallery-json')
        let selectedSlug = $(this).attr('data-term-slug')
        let images = JSON.parse(selectedVariation)
        let imagesContainer = $('#imageContainer')
        $('.variation-product').removeClass('selected disabled')
        $('.product-images').addClass('loading')
        $(this).addClass('selected')
        imagesContainer.empty()
        images.forEach(image => {
          imagesContainer.append('<div data-src="' + image + '" class="img-box"><img src="' + image + '"></div>')
        });
        setTimeout(() => {
          $('.product-images').removeClass('loading')
          if($(window).width() <= 768) { glalerySlider() }
          $('#imageContainer').lightGallery({
            selector: '.img-box',
          })
        }, 400)
        $('#pa_colour').val(selectedSlug).trigger('change')
        $('#pa_size-men').trigger('change')
        $('#active-color').text($(this).attr('data-term-name'))
      })
  
      function glalerySlider() {
        var options = {
          slidesToShow: 1,
          loop: false,
          dots: true,
          arrows: false,
          infinite: false,
          customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data('src')
            return '<a><img src="' + thumb + '"></a>'
          },
        }
        $('#imageContainer').slick(options)
      }
  
      $('#pa_colour').change(function () {
        setTimeout(() => {
          $('#pa_size-men option').map(function () {
            if(!$(this).hasClass('enabled')) {
              let disableSizes = $(this).val()
              console.log(disableSizes, 'color change disableSizes');
              $('.sizes-container button[data-term-slug="'+disableSizes+'"]').prop('disabled', true)
            } else {
              $('.sizes-container button').prop('disabled', false)
            }
          })
        }, 500)
      })
  
      $('#pa_size-men').change(function () {
        setTimeout(() => {
          $('#pa_colour option').each(function () {
            if($(this).prop('disabled')) {
              let disableSizes = $(this).val()
              $('.variation-product[data-term-slug="'+disableSizes+'"]').addClass('disabled')
              console.log(disableSizes, 'size change disableSizes')
              return false
            } else {
              console.log('else')
              $('.variation-product').removeClass('disabled')
            }
          })
        }, 500)
      })  

    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js